import AppUrlLib from '@libs/appUrl'

export const googleFormUrl = 'https://forms.gle/PrjxuAyYiSgik2NR7'

const questionData = [
  {
    title: '帳號問題',
    questions: [
      {
        title: '忘記註冊方式，該怎麼辦呢？',
        content: `
        <div>請填寫 <a href="${googleFormUrl}">常見問題與回報</a> 表單，並提供以下資料，波編將會盡快協助您！</div>
        <ul>
          <li>過去發布文章的網址</li>
          <li>會員 ID（如果還記得)</li>
        </ul>`,
      },
      {
        title: 'App 無法註冊登入、頻頻閃退，該怎麼辦呢？',
        content: `
        <div>PopDaily 團隊每日都在進行功能的完善與優化，如果遇到 App 閃退的情況，建議您可以先移除 App 重新下載。如果仍不能使用，請填寫 <a href="${googleFormUrl}">常見問題與回報</a> 表單，並提供以下資料，波編將會盡快協助您！</div>
        <ul>
          <li>手機型號（e.g. iPhone 11 pro）</li>
          <li>手機系統版本（e.g. iOS 13.1）</li>
          <li>波波 APP 版本（在 APP “我的” 頁面中，點下 ⚙️ 就能找到囉，e.g. v1.1.6）</li>
        </ul>`,
      },
    ],
  },
  {
    title: '平台內容問題',
    questions: [
      {
        title: '內容是否有審核機制？',
        content: `
        <div>
        PopDaily 針對平台內容進行嚴格把關，任何暴力、色情的內容都將予以禁止，詳情可查看我們的 <a href="${AppUrlLib.appUrl}/policy/content-policy">社群守則</a>。
    </div>`,
      },
      {
        title: '在平台上看到色情、暴力的內容，該怎麼辦呢？',
        content: `
        <div>
        <ul>
          <li>Web：在文章頁裡，點擊文章封面圖右上角的 「。。。 」→ 「檢舉」機型號（e.g. iPhone 11 pro）</li>
          <li>App：在文章頁裡，點擊固定在頁面下方操作欄的「。。。」 → 「檢舉」</li>
        </ul>
        </div>
        `,
      },
      {
        title: '在平台上看到疑似抄襲的內容，該怎麼辦呢？',
        content: `
    <div>PopDaily 非常重視平台上創作者內容的原創性，如發現疑似抄襲的內容，可以填寫 <a href="${AppUrlLib.appUrl}/about/copyright">版權回報</a> 表單。一旦發現內容屬於抄襲，我們將會第一時間下架文章，保護創作者權益！</div>
    `,
      },
    ],
  },
  {
    title: '功能使用問題',
    questions: [
      {
        title: '如何關閉推播通知？',
        content: `
        <div>
    可以在手機裡面的「設定」找到 PopDaily App 再將通知關閉。貼心提醒您，PopDaily 經常有 App 專屬的活動跟限量驚喜，開啟推播通知能確保您收到第一手的消息喔！
    </div>`,
      },
      {
        title: '如何編輯已發文文章呢？',
        content: `
        <div>
        <ul>
          <li>Web：在文章頁裡，點擊文章封面圖右上角的 「。。。」 → 「編輯」</li>
          <li>App：在文章頁裡，點擊固定在頁面下方操作欄的「。。。」 → 「編輯」</li>
        </ul>
        </div>
        `,
      },
      {
        title: '如何新增打卡點呢？',
        content: `
    <div>目前由於「地圖」功能下線，已經不再提供新增打卡點的服務囉！</div>
    `,
      },
    ],
  },
  {
    title: '創作者相關問題',
    questions: [
      {
        title: '我也想撰寫「圖文穿插」的格式，該如何開始呢？',
        content: `
        <div>
        目前圖文穿插格式僅限於「波波編輯」與「平台認證的創作者」使用，可以申請加入 <a href="${AppUrlLib.appUrl}/poper">PopDaily 創作者計畫</a> 喔！
    </div>`,
      },
      {
        title: '什麼是 PopDaily 創作者計畫？',
        content: `
        <div>
          詳情請查看 <a href="${AppUrlLib.appUrl}/forum/life/699250">PopDaily 創作者計畫問與答</a>。
        </div>
        `,
      },
      {
        title: '要如何知道自己是否為創作者呢？',
        content: `
    <div>
    我們提供創作者專屬客服服務，請傳送訊息至 LINE@（LINE ID: @nvz8256p）或寄信至信箱（creators@sugoigroup.tw）將會有客服與您聯繫。
</div>
    `,
      },
    ],
  },
]

export default questionData
